import styled, { keyframes } from "styled-components";
import { theme } from "../../styles/theme";

const notifPulse = keyframes`
    0%, 100% { box-shadow: 0 0 0 0 rgba(255, 82, 82, 0.7); }
    50%       { box-shadow: 0 0 0 5px rgba(255, 82, 82, 0); }
`;

export const NotifCountBadge = styled.span`
    position: absolute;
    top: -6px;
    right: -8px;

    min-width: 17px;
    height: 17px;
    padding: 0 4px;

    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 50px;
    background-color: #FF5252;

    font-family: 'Lato', sans-serif;
    font-size: 9px;
    font-weight: 700;
    color: #fff;
    line-height: 1;

    animation: ${notifPulse} 2s ease-in-out infinite;
    pointer-events: none;
`;

export const Container = styled.div`
    width: 100%;
    height: auto;
    padding: 1rem 2rem;

    gap: 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;

    border-bottom: 0.125rem solid #F3F3F5;

    @media (max-width: 790px) {
        padding: 32px 16px;
    }

    @media (max-width: 479px) {
        padding: 32px 1rem;
    }
`;

export const ContainerSubscribeAndUser = styled.div`
    width: auto;
    height: auto;
    min-width: 0;

    gap: 0.5rem;
    display: flex;
    align-items: center;

    > a {
        flex-shrink: 0;
    }

    @media (max-width: 760px) {
        width: ${({ gap }) => (gap ? '100%' : '')};;
        min-width: 0;
        flex-direction: ${({ alignLeft }) => (alignLeft ? 'row' : 'row-reverse')};
        justify-content: ${({ alignLeft }) => (alignLeft ? 'flex-start' : 'space-between')};
        margin-top: ${({ gap }) => (gap ? '-0.3rem' : '0')};
    }

    @media (max-width: 479px) {
        width: 100%;
    }
`;

export const MobileMenuButton = styled.button`
    all: unset;

    display: none;
    flex-shrink: 0;
    cursor: pointer;

    > img {
        width: 20px;
        height: 20px;
        cursor: pointer;
    }

    @media (max-width: 760px) {
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;

export const TitleGroup = styled.div`
    width: auto;
    height: auto;
    min-width: 0;

    gap: 0.5rem;
    display: flex;
    align-items: center;
`;

// Layout de duas linhas usado só em ≤760px (ver isCompactHeader) - título
// sozinho na 1ª linha, com espaço garantido pra não ser espremido pelo
// pill de plano (que tem white-space: nowrap e não cede espaço); pill +
// seletor de período (rightSlot) descem pra 2ª linha.
export const MobileHeaderStack = styled.div`
    width: 100%;

    gap: ${({ hasPeriodSelector }) => (hasPeriodSelector ? '1rem' : '0.75rem')};
    display: flex;
    flex-direction: column;
`;

export const MobileSecondaryRow = styled.div`
    width: 100%;

    gap: 0.5rem;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
`;

export const SubscribeButton = styled.button`
    all: unset;

    width: auto;
    height: 1.25rem;
    padding: 0.25rem 0.5rem;

    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;
    border-radius: 2rem;
    background-color: #589BFF;

    > span {
        white-space: nowrap;
        cursor: pointer;

        color: #FFFFFF;
        font-weight: 800;
        font-size: 0.5625rem;
        letter-spacing: 0.1rem;
        line-height: 0.84375rem;
        font-family: "Lato", Sans-serif;
    }

    :hover {
        opacity: 0.7;
    }
`;

export const ManagePlansButton = styled.button`
    all: unset;

    width: auto;
    height: 1.25rem;
    padding: 0.25rem 0.5rem;

    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;
    border-radius: 2rem;
    background-color: #E9ECF0;

    > p {
        white-space: nowrap;
        cursor: pointer;
    }

    > span {
        white-space: nowrap;
        cursor: pointer;
    }

    :hover {
        opacity: 0.7;
    }
`;

export const UserName = styled.div`
    width: auto;
    height: auto;
    min-width: 0;

    display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;

    > h4 {
        @media (max-width: 790px) {
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            
            text-align: start;

            font-size: ${({ titleFontSize }) => titleFontSize || '1rem'};
            line-height: ${({ titleFontSize }) => titleFontSize || '1rem'};
        }

        @media (max-width: 601px) {
            max-width: 15rem;   
        }
        
        @media (max-width: 422px) {
            max-width: 12rem;
        }
    }
`;

export const ContainerNotificationAndProfile = styled.div`
    width: auto;
    height: auto;

    gap: 0.5rem;
    display: flex;
    align-items: center;
`;

// Sino + perfil - separado num grupo próprio (em vez de ficar solto direto
// em ContainerNotificationAndProfile) só pra poder sumir no mobile (≤479px,
// já era assim antes) sem levar junto o rightSlot (ex.: o seletor de período
// da tela de Relatórios), que precisa continuar visível.
export const BellProfileGroup = styled.div`
    width: auto;
    height: auto;

    gap: 0.5rem;
    display: flex;
    align-items: center;

    @media (max-width: 479px) {
        display: none;
    }
`;

// Slot pra conteúdo extra vindo de rightSlot (ex.: o seletor de período da
// tela de Relatórios) - fica ao lado do sino/perfil em telas maiores, mas
// continua visível no mobile mesmo quando o sino/perfil some.
export const PeriodSelectorSlot = styled.div`
    width: auto;
    display: flex;
    align-items: center;
`;

export const ContainerNotification = styled.button`
    all: unset;

    position: relative;

    width: 3rem;
    height: 3rem;

    display: flex;
    align-items: center;
    justify-content: center;

    > a {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    > a > img {
        width: 1.25rem;
        height: 1.25rem;

        cursor: pointer;
        border-radius: 10rem;
        filter: brightness(0.4);
    }

    @media (max-width: 760px) {
        display: none;
    }
`;

export const Profile = styled.div`
    position: relative;

    width: auto;
    height: auto;
    padding: 0.3rem 0.5rem 0.3rem 0.3rem;

    gap: 0.5rem;
    display: flex;
    align-items: center;

    cursor: pointer;
    border-radius: 10rem;
    background-color: #F3F3F5;

    > img {
        width: 2rem;
        height: 2rem;

        border-radius: 10rem;
    }

    > p {
        cursor: pointer;
    }
`;

export const NameProfile = styled.div`
    width: 2rem;
    height: 2rem;

    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 10rem;
    background-color: ${theme.colors.gray.Cinza_2};

    >span{
        cursor: pointer;

        color: #FFFFFF;
    }
`

export const ButtonProfile = styled.button`
    all: unset;

    display: flex;
    align-items: center;

    cursor: pointer;
`;

export const Accordion = styled.div`
    top: 315%;
    left: 45%;
    position: absolute;
    transform: translate(-50%, -50%);

    z-index: 10;
    width: 10rem;  

    display: flex;
    flex-direction: column;

    background: #fff;
    border-radius: 0.5rem; 
    border: 0.0625rem solid #ddd;
    box-shadow: 0 0.125rem 0.625rem rgba(0, 0, 0, 0.1);  

    a{
        padding: 0.5rem 1rem;  

        display: flex;
        justify-content: center;

        color: ${theme.colors.gray.Cinza_2};
        cursor: pointer;
        font-size: 0.625rem; 

        &:hover {
          background-color: #f5f5f5;
        }
    }

    @media (max-width: 769px) {
        right: -0.9125rem; 
    }
`;

export const AccordionItem = styled.label`
    padding: 0.5rem 1rem;  

    display: flex;
    justify-content: center;

    color: ${theme.colors.gray.Cinza_2};
    cursor: pointer;
    font-size: 0.625rem;   

    &:hover {
        background-color: #f5f5f5;
    }
`;

export const ContainerModal = styled.div`
    width: 100%;
    height: auto;
    max-width: 50rem;

    display: flex;
    align-self: center;
    justify-content: center;
`;

export const LoadingContainer = styled.div`
    width: 50rem;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;

    @media (max-width: 760) {
        width: 100%;
    }
`

export const Loading = styled.div`

  @-webkit-keyframes rotating /* Safari and Chrome */ {
    from {
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }
    
  @keyframes rotating {
    from {
        -ms-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -ms-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }


  width: 80px;
  height: 80px;
  position: relative;

  background-color: transparent;
  border-top: 1px solid #2fbb69;
  border-bottom: 1px solid #2fbb69;
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  border-radius: 50%;
  -webkit-animation: rotating 0.7s linear infinite;
  -moz-animation: rotating 0.7s linear infinite;
  -ms-animation: rotating 0.7s linear infinite;
  -o-animation: rotating 0.7s linear infinite;
  animation: rotating 0.7s linear infinite;

`;